import React from 'react';
import './SkinEyeCarePage.css';
import { Link } from 'react-router-dom';

const SkinEyeCarePage = () => {
  return (
    <main className="skin-eye-care-main">
      {/* Hero Section */}
      <section className="skin-eye-care-hero">
        <div className="skin-eye-care-hero-content">
          <h1>Skin & Eye Care Film</h1>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="skin-eye-care-content">
        {/* Skin & Eye Care Series Section */}
        <div className="series-section">
          <div className="series-content">
            <h2>Skin & Eye Care Series – Advanced Full-Spectrum UV Protection for You and Your Passengers</h2>
            <p>At Derma Protec Films, your health and comfort come first—especially when you're on the road. That's why our Skin & Eye Care Series is designed with more than just heat rejection in mind. This series offers cutting-edge, full-spectrum UV protection, shielding you and your loved ones from harmful rays every time you step into your vehicle.</p>
            
            <div className="spectrum-defense">
              <h3>True Full Spectrum Defense</h3>
              <p>Traditional automotive window films only block UV rays up to 380nm—which leaves your skin and eyes vulnerable to longer UVA rays that penetrate deeper into the skin. Our Skin & Eye Care Series is engineered with Full UV Technology, offering protection across the entire UV spectrum (UVA, UVB, and UVC)—up to 400nm.</p>
              <p>This means your vehicle windows become a protective barrier against sun damage, premature aging, and even skin cancers linked to UV exposure.</p>
            </div>
          </div>
        </div>

        <div className="content-block">
          <div className="content-text">
            <h2>The Technology Behind the Protection</h2>
            <p>Our films feature advanced Infusion Technology—a revolutionary manufacturing process that permanently embeds UV-blocking agents within the PET layer of the film. Unlike surface-coated films that wear down over time, our protection is built-in, long-lasting, and resistant to environmental wear and tear.</p>
            <ul>
              <li>No fading</li>
              <li>No peeling of coatings</li>
              <li>No reduction in UV performance over time</li>
            </ul>
            <p>You get consistent, reliable defense for the life of the film.</p>
          </div>
          <div className="content-image">
            <img 
              src="https://i.postimg.cc/j2302t2J/skin-eye-care-image-1-page-001-1535448725-37-39-61-226-1.jpg" 
              alt="Skin & Eye Care Film Application" 
              className="feature-image"
            />
          </div>
        </div>

        {/* Why It Matters Section */}
        <div className="why-matters-section">
          <div className="why-matters-content">
            <h2>Why It Matters: Skin & Eye Health on the Road</h2>
            <p>The interior of a car may feel safe, but up to 50% of harmful UV rays can still penetrate untreated windows. Over time, this exposure accumulates and poses real health risks.</p>
            
            <div className="health-risks">
              <h3>Prolonged UV and blue light exposure can lead to:</h3>
              <ul>
                <li>Premature skin aging and sunspots</li>
                <li>Increased risk of melanoma and other skin cancers</li>
                <li>Eye damage such as cataracts or macular degeneration</li>
                <li>Fatigue and glare-related vision issues</li>
              </ul>
            </div>
            
            <p>With our Skin & Eye Care Series, you can drive with peace of mind knowing your skin, eyes, and passengers are protected—whether you're commuting daily or on long road trips.</p>
          </div>
        </div>

        {/* Performance Benefits Section */}
        <div className="performance-benefits-section">
          <h2>Performance Benefits at a Glance</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <div className="benefit-content">
                <h3>100% UV Radiation Blockage</h3>
                <p>Blocks UVA, UVB & UVC rays up to 400nm for comprehensive health protection.</p>
              </div>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-content">
                <h3>Blue Light Rejection</h3>
                <p>Filters high-energy visible (HEV) blue light, reducing glare and minimizing eye strain and fatigue.</p>
              </div>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-content">
                <h3>High Solar Heat Reflection</h3>
                <p>Enhances comfort by significantly reducing cabin heat buildup, lowering air conditioning usage, and improving fuel efficiency.</p>
              </div>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-content">
                <h3>Optical Clarity & Sleek Finish</h3>
                <p>Maintains crystal-clear visibility without compromise, adding a subtle, stylish aesthetic to your vehicle.</p>
              </div>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-content">
                <h3>Fade Reduction for Interiors</h3>
                <p>Protects your dashboard, seats, and interior materials from fading and discoloration over time.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Perfect for Every Driver Section */}
        <div className="perfect-driver-section">
          <h2>Perfect for Every Driver</h2>
          <h3>The Skin & Eye Care Series is ideal for:</h3>
          <ul>
            <li>Parents with children</li>
            <li>Daily commuters</li>
            <li>Elderly passengers or those with sensitive skin</li>
            <li>Drivers concerned about long-term exposure</li>
            <li>Anyone prioritizing comfort and wellness inside the car</li>
          </ul>
          <h3>Invest in More Than Just Tint — Choose Protection with Purpose</h3>
          <p>With the Derma Protec Skin & Eye Care Series, you're not just upgrading your windows—you're making a long-term investment in health, safety, and comfort. Backed by industry-leading film technology and warranties, this series is the smart choice for the health-conscious driver.</p>
          <p><strong>Drive safer. Drive smarter. Drive protected—with Derma Protec.</strong></p>
        </div>

        {/* Visual Comparison Section */}
        <div className="visual-comparison-section">
          <h2>Visual Comparison Chart: Standard Tint vs. Skin & Eye Care Series</h2>
          <p>See how Derma Protec's Skin & Eye Care Series outperforms standard window films.</p>
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Standard Window Film</th>
                  <th>Skin & Eye Care Series</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>UV Protection</td>
                  <td>Up to 380nm (UVA/UVB)</td>
                  <td>Full 100% UV (UVA/UVB/UVC) up to 400nm</td>
                </tr>
                <tr>
                  <td>Blue Light Rejection</td>
                  <td>Limited</td>
                  <td>✔ Yes – Filters harmful HEV light</td>
                </tr>
                <tr>
                  <td>Heat Rejection</td>
                  <td>Moderate</td>
                  <td>✔ High solar heat reflection</td>
                </tr>
                <tr>
                  <td>UV Technology</td>
                  <td>Surface-coated</td>
                  <td>✔ Infused into PET layer (won't degrade)</td>
                </tr>
                <tr>
                  <td>Skin & Eye Safety</td>
                  <td>Partial protection</td>
                  <td>✔ Medical-grade full-spectrum protection</td>
                </tr>
                <tr>
                  <td>Glare Reduction</td>
                  <td>Some</td>
                  <td>✔ Enhanced, with optical clarity</td>
                </tr>
                <tr>
                  <td>Longevity</td>
                  <td>May fade or peel</td>
                  <td>✔ Long-lasting, no performance loss</td>
                </tr>
                <tr>
                  <td>Interior Fade Protection</td>
                  <td>Moderate</td>
                  <td>✔ Excellent – Preserves dashboard, leather, trims</td>
                </tr>
                <tr>
                  <td>Comfort Level</td>
                  <td>Standard</td>
                  <td>✔ Premium cabin comfort year-round</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="specs-table-wrapper">
            <table className="specs-table">
              <thead>
                <tr>
                  <th>Model</th>
                  <th>VLT</th>
                  <th>IRR</th>
                  <th>UVR</th>
                  <th>O.D</th>
                  <th>TSER</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>DPSK-05</td><td>5%</td><td>100%</td><td>100%</td><td>1.21</td><td>86%</td></tr>
                <tr><td>DPSK-10</td><td>10%</td><td>100%</td><td>100%</td><td>0.87</td><td>85%</td></tr>
                <tr><td>DPSK-20</td><td>20%</td><td>100%</td><td>100%</td><td>0.71</td><td>84%</td></tr>
                <tr><td>DPSK-30</td><td>30%</td><td>100%</td><td>100%</td><td>0.54</td><td>81%</td></tr>
                <tr><td>DPSK-50</td><td>50%</td><td>100%</td><td>100%</td><td>0.46</td><td>75%</td></tr>
                <tr><td>DPSK-60</td><td>60%</td><td>100%</td><td>100%</td><td>1.33</td><td>68%</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <h2>Experience the Difference</h2>
          <p>Join thousands of satisfied customers who trust Derma Protec for their skin and eye protection needs.</p>
          <div className="cta-buttons">
            <Link to="/find-dealer" className="cta-button primary">Find a Dealer Centre</Link>
            <Link to="/contact" className="cta-button secondary">Contact Us</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SkinEyeCarePage; 